module.exports = __webpack_public_path__ + "static/media/background-618-plain.43b41b96.png";